import {useDispatch} from "react-redux";
import { addItem } from "../utils/cartSlice";

const CartItem = ({item}) => {

    const dispatch = useDispatch();

    const addItemHandler = (inc) => {
      dispatch(addItem({ ...item, quantity: item.quantity + inc }));
    };

    return (
      <article className="grid grid-cols-4 my-4 px-4">
        <div className="col-span-3 px-2">
          <h5 className="text-xs sm:text-sm font-medium">{item.name}</h5>
          <h6 className="text-xs font-semibold bg-cyan-500 w-fit px-2 py-1 mt-1 rounded-full">
            <span>&#8377;</span>
            {(item.price / 100) * item.quantity}
          </h6>
        </div>
        <div className="flex w-full sm:w-4/5 mx-auto text-xs sm:text-sm font-medium text-cyan-500 h-fit py-1 shadow-md rounded-md">
          <button className="w-1/3" onClick={() => addItemHandler(-1)}>
            -
          </button>
          <span className="text-center w-1/3">{item.quantity}</span>
          <button className="w-1/3" onClick={() => addItemHandler(1)}>
            +
          </button>
        </div>
      </article>
    );
}
export default CartItem;